import { defineStore } from 'pinia';
import { CarPlacementSaleReportsRequestFilter } from '@/types/report.type.ts';

export const useCarPlacementSaleReportsFilterStore = defineStore('reports.car-placement-sale-reports.filter', {
    state: (): CarPlacementSaleReportsRequestFilter => ({
        year: undefined,
        month: undefined,
        dealer_id: undefined,
        page: 1,
        sort: [{ dealer_name: 'asc' }],
    }),
});
